/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import { LoadingGif } from 'assets';
import { Method } from 'axios';
import IconButton from 'components/IconButton';
import callApi from 'lib/callApi';
import React, { useState, useEffect } from 'react';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

interface Config {
  url: string;
  urlParams: any;
  label: string;
  fileName: string;
}

interface Props {
  buttonId: string;
  iconClass: string;
  tooltip: string;
  config: Config[];
  method: Method;
  disabled?: boolean;
  className?: string;
  data?: any;
  headers?: any;
  onSuccessCallback?: () => void;
  onFailureCallback?: (message) => void;
}

const FileDownloadDropdown: React.FC<Props> = ({
  buttonId,
  iconClass,
  tooltip,
  config,
  method,
  disabled = false,
  className,
  data = null,
  headers = null,
  onSuccessCallback,
  onFailureCallback,
}) => {
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDownloadIndex, setSelectedDownloadIndex] = useState(0);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const downloadFile = async (url, urlParams, fileName) => {
    if (url && urlParams) {
      callApi(url, method, urlParams, data, headers)
        .then((res) => {
          if (res.status === 201 || res.status === 200) {
            var data = res.data;
            setLoading(false);
            var blob = new Blob([data], { type: 'text/csv' });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            if (onSuccessCallback) onSuccessCallback();
          } else {
            setLoading(false);
            console.error({
              function: 'downloadFile',
              error: `Unexpected response: ${res.status}`,
              res,
            });

            if (onFailureCallback)
              onFailureCallback('Failed to download file.');
          }
        })
        .catch((err) => {
          setLoading(false);
          console.error({
            function: 'downloadFile',
            error: err,
          });
          if (onFailureCallback) onFailureCallback('Failed to download file.');
        });
    }
  };

  const handleExport = (index, url, urlParams, fileName) => {
    setSelectedDownloadIndex(index);
    setLoading(true);
    downloadFile(url, urlParams, fileName);
  };

  useEffect(() => {
    setLoading(false);
  }, [selectedDownloadIndex]);

  const Spinner = () => {
    return (
      <img className="bg-img x-sm" src={LoadingGif} alt="downloading..." />
    );
  };

  return (
    <>
      <Dropdown isOpen={isOpen} toggle={toggleDropdown}>
        <DropdownToggle tag="span" nav className="m-0 p-0">
          <IconButton
            id={buttonId}
            disabled={disabled}
            iconClass={iconClass}
            tooltip={tooltip}
            onClick={toggleDropdown}
            cssClass={className}
          />
        </DropdownToggle>
        <DropdownMenu
          className="dropdown"
          right
          tag="ul"
          style={{
            minWidth: 'max-content',
            maxWidth: '240px',
            cursor: 'pointer',
          }}
        >
          {config.map((item, index) => {
            const { label, fileName, url, urlParams } = item;
            return (
              <DropdownItem
                key={index}
                onClick={() => handleExport(index, url, urlParams, fileName)}
                style={{
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  cursor: 'pointer',
                  color: '#000000',
                }}
              >
                {loading && selectedDownloadIndex === index && <Spinner />}
                {label}
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default FileDownloadDropdown;
